import { parseSearchState } from '@faststore/sdk'

export const getFacetsFromUrl = (searchUrl: string) => {
  const origin = window?.location?.origin
  const newUrlForSearch = new URL(
    searchUrl?.indexOf(origin) !== -1 ? searchUrl : `${origin}${searchUrl}`
  )

  return newUrlForSearch?.search
    ? parseSearchState(newUrlForSearch)?.selectedFacets
    : []
}
